# Appendix: Team Shoutouts

## Teams doing fun stuff

**decompals** having a fun time using tldraw to solve Multiverse of Mixups  
<Image nameWithExt="wrapup/image1.png" />  
<Image nameWithExt="wrapup/image2.png" />  
<Image nameWithExt="wrapup/image3.png" />

An email from **:praytrick:** about Picturini Puzzlelini  
<Image nameWithExt="wrapup/image4.png" />

**RP Diem** pondering the orbs on Polygons (image credit to teammate Triscuit)  
<Image nameWithExt="wrapup/image5.png" />

**RP Diem** after they solved Polygons  
[https://i.imgur.com/uvBoDSV.mp4](https://i.imgur.com/uvBoDSV.mp4)

**Literally Laurasia**  
<Image nameWithExt="wrapup/image6.png" />

**Literally Gondwana**  
[https://i.imgur.com/zqmJEXj.mp4](https://i.imgur.com/zqmJEXj.mp4)

**🪿 Geese Lightning 🪿**: the struggle is real  
<Image nameWithExt="wrapup/image6-1.png" />

**🪿 Geese Lightning 🪿** on Debbie Downers  
<Image nameWithExt="wrapup/image7.png" />

🥚👍 on Turtles All the Way Down  
<Image nameWithExt="wrapup/image8.png" />

**Salutecissimus** with a trilingual solve of Spooflantu Cultural Exchange  
<Image nameWithExt="wrapup/image9.png" />

## Funny hint requests

**The Managers** on Picturini Puzzlelini:  
And while (some of us) are pretty proud of ourselves

**The Metaphysical Kids** on Picturini Puzzlelini  
<Image nameWithExt="wrapup/image10.png" />

**Excessive Congers of r/PictureGame** on Seven Puzzles  
<Image nameWithExt="wrapup/image11.png" />

**JඞKER? I HARDLY KNඞW HER\!** prepared us a nice landing page linked in their spreadsheet  
<Image nameWithExt="wrapup/image12.png" />

**What’s in My Mouth?** found a crazy red herring between Symbolic Computation and Taxononogramy <Image nameWithExt="wrapup/image13.png" />

**SPecial oPS**  
<Image nameWithExt="wrapup/image14.png" />

**Ultimate Brownies** on Pay $7,999,999 To Access The Premium Version Of This Puzzle<Image nameWithExt="wrapup/image15.png" />

**Builders’ Guild**  
<Image nameWithExt="wrapup/image16.png" />

**Luigi's Death Stare**: We've included a really cute puppy photo as payment
<Image nameWithExt="wrapup/image17.png" />

**Corgaroos** on Okay Fine (the entire content of this puzzle is “The answer to this puzzle is FAIR PLAY.”)  
<Image nameWithExt="wrapup/image18.png" />

Our own meme about staffing the hint queue  
<Image nameWithExt="wrapup/image19.png" />

## Funny guesses

**Four Pieces**

* *First correct submission of the hunt, at 18:56:16!*
  * DIFFUSED LIGHT (Have You Tried Drinking More Milk?)
* AURORA AUSTRALIS (TheBigFish)
* BEER GOGGLES (Boxmail)
* PROCEED TO GAZEBO (LUNELAPI)
* PUZZLE OF COINCIDENCE (orz TropicoMango)
* YOU FIZZLED AGAIN (Harvard Orzers)

**Ring Cycle**

* THE RING (four different teams)
* *Some guesses were about Wagner’s “Ring Cycle” operas.*
  * DIE WALKURE (cat bird) (The High+ Schoolers)
  * WOTAN (Moose Eating Bat) (flossers 剔牙爱好者🦷🦷🦷)
  * BRUNNHILDE (TEAM.KATHARSIS)
  * DWARVES (何以为我)

**The Blue Theatre**

* *These are all names apparently similar to the correct answer ETTA JAMES.*
  * MATT JAMES (The Inedibles)
  * ZETA JONES (Joat) (inter oves)
  * KING JAMES (TheBigFish) (CyFur)
  * EDWARD III (The C@r@line Syzygy)
  * SAINT JOHN (CyFur)
  * ST JAMES (SPecial oPS)
  * LEBRON (Mushroom Kindergarten)
  * PAT METHENY (TEAM.KATHARSIS)
  * FRANK (three different teams)

**A Confusing Journey**

* BITTSBURG (The Jovial Puzzlers)
* FIRSTYOUVISITDC (I-land Hoppers)

**One-Time Use**

* GALACTICARDCAPTORS (crunchy ice)
* *But what does it do?*
  * I PLAY POT OF GREED WHICH ALLOWS ME TO DRAW TWO CARDS FROM MY DECK AND ADD THEM TO MY HAND (JඞKER? I HARDLY KNඞW HER\!)

**Unfamiliar Characters**

* UNFAIR PLAY (TErra firMA)
* YALL REALLY GAVE US THE PIECE WITH THE UP ARROW LAST ARE YOU KIDDING ME (Dan City)

**Picturini Puzzlelini**

* SENDETTO CAPITALETTI (Wolstenholme's Martinis)
* SENDINI CAPITALINI (Chicken & ROFLs)
* SENDO DOLLARO (bagel)
* FAIRINI PLAYLINI (meowzle)
* BRR BRR PATAPIM BRR BRR PATAPIM CHIMPANZINI BANANINI TUNG TUNG TUNG SAHUR (acbd)
* CAN SOMEONE GO CHECKUP ON PAN (Terrestrial Species Being Invented)
* E (five different teams)
* PLEASE ADD NSFW WARNING THE PICTURES ARE VERY HORRIFYING (似是而非之证妍)
* HELP WE ARE LOSING BRAINCELLS (Ladder Gods)
* TRALALERO TRALALA PLS HELP ME YOU ARE MY ONLY HOPE (acbd)
* I KNOW I HINTED THIS BUT I AM GENUINELY TOO BOOMER TO UNDERSTAND ANY OF THIS (Pepsimen)

**Multiverse of Mixups**

* NEIL HAMBURGER (The Roundabout Way)
* BALLS OF MEAT (:praytrick:)
* ILL SEND YOU MY IG (Team Cirno)
* DOCTOR STRANGE (Plugh (pronounced “yermom”))
* THAT SHOULD HAVE WORKED (Plugh (pronounced “yermom”))

**A Student’s Diary**

* CONJUNCTIVITIS (The Agency) (Marple (thinking of an alternative very loudly))
* ISNT IT A LITTLE DRAMATIC FOR PEARL TO PROPOSE TO MR MORTON WITHOUT HAVING GONE ON A DATE WITH HIM OR ANYTHING I MEAN MR MORTON SEEMS LIKE A LOVELY GUY BUT SURELY YOUVE GOTTA AT LEAST GET TO KNOW HIM FIRST ANYWHERE WERE STUCK ON EXTRACTION (Lavosh mysteryuri corn thins (7))
* GET SOME REST ("1. Puzzle Me This 2\. Quantic Quandaries 3\. The Codebreakers 4\. Infinite Loopers 5\. Puzzling Pythons Hope these click with your team\! Would you like more options or a tweak to any of these?" \~ChatGPT)

**square**

* FOR ONCE YOU ARE CORRECT IN FINDING THE ANSWER (natoptishi)
* HINT WAS REALLY HELPFUL THANK YOU OMNISCIENT PUZZLE BEINGS IN THE SKY (Lavosh mysteryuri corn thins (7))

**Chains**

* *This team had solved the metapuzzle even before they unlocked it.*
  * SURELY WE WOULD UNLOCK THE META BY NOW (ˈtɛrə ɔːˈstrælɪs)
* WHAT IS THAT LITTLE DUDE IN THE BOTTOM RIGHT WHAT IS IT DOING (Builders' Guild)
* TURNS OUT THE LITTLE DUDE IN THE BOTTOM RIGHT IS AN ELEPHANT (Builder's Guild)

**Spirit Island**

* BANJO KAZOOIE (Glub Glub)

**Surviving the Open World**

*The first metapuzzle solve in the hunt occurred **at the same second** by two different teams.*
<Image nameWithExt="wrapup/image20.png" />

* *Good pun! But not quite right.*
  * CONTINENTAL RAFT (Seattle Kraken the Code)

**Symbolic Computation**

* UNDERSCORE (Underscore\_)

**Seven Puzzles**

* THIS IS THE ONLY PUZZLE WE HAVE OPEN OK FINE ACTUALLY ITS 7 PUZZLES BUT WE SOLVED 3 OF THEM NOW ITS ONLY 4 PUZZLES AND WE ARE HARD STUCK ON THEM AND WE EVEN KNOW THE SOLUTION TO MOST OF THE REST OF THE PUZZLES IN THE ROUND BUT NEED MORE PIECES (KaBaL)

**Polygons**

* META DIAGONAL (five different teams)
* BANACH TARSKI (The Blob Wizards)
* POLYGONS ARE JUST SHAPES THEY CANNOT HURT YOU THE POLYGONS IN QUESTION (acbd)
* THE HAND OF GOD (野炊含有不适宜内容)
* *Throwback to GPH 2024\.*
  * ELONGATED GYROBIFASTIGIUM (decrypt this hunt)

**Taxononogramy**

* BONGCLOUD (Organic Mathemagicians Inhabit Nascent Orb Using Soil)

**Four Square**

* DOUBLED FEMALE SIGN (Universe Uniting Underlings)
* YURI (Universe Uniting Underlings)
* MYCABBAGES (🪿 Geese Lightning 🪿)

**Not So Fast**

* ALL I DO IS WIN (Pan Asssigns Newly-formed Gaia As Earth's Attendant, Unfortunately Lunacy's Threatened. Invoking Mathemagicians Advised)
* TO THE VICTOR GOES THE SPOILS (CyFur)
* WATER PER HOUR (Team JUSTeam)

**Questions and Answers**

* BARREL ROLL (priMA TErra)
* ELF IN BROWSER (bucket of huntere)
* SUOMEN TASAVALTA (野炊含有不适宜内容)
* *Some teams tried to backsolve this puzzle by observing that the Google Sheets logo has the right pattern.*
  * GOOGLESHEETS (five different teams)

**The Web**

* ROCKET SNAIL (nine different teams)
* BROOM AND DUSTPAN (cruciverbalists)
* REFRESH THE SITE (Kohnsteweition Hanters)
* CLEANSE BRAIN ROT (The Hunt Slayers)
* DESTROY THE WEBSITE (😯🙌🏻👾🤖🤸‍♂️👺🌠🤲👻🖐️🛸😃)
* GO ON THE DARK WEB (sufficientlylargen)
* GO TO A SEEDY SITE (String Cheese Theory)
* YOU USE YOUR EYE AND EAR AND MAGNIFYING GLASS TO TRACK DOWN A CRANE AND YOU BRING IT THROUGH THE DESERT AND CITY AND STADIUM VIA TRAIN AND ROAD AND FINALLY A CRUISE SHIP UNTIL YOU REACH THE ISLAND WHERE IT CAN HELP RECONSTRUCT (🍓➡️🐢)

**Turtles All the Way Down**

* STURGILL ALTERNATES BETWEEN HOWLING AND ALMOST GROWLING (Unencrypted)

**Debbie Downers**

* DOWN TO BE WRONG (反卷不抽卡)

**Across the Pond**

* BRING BACK THE CARD GAME PUZZLES YOU COWARDS NO REALLY PLEASE BRING THEM BACK DONT LISTEN TO HER DONT BRING THEM BACK (Shower Pomelo 🍈)
* NO (Eagle Time)

**(A)isle of Crosswords**

* GOOD RAIN DANCE (three different teams)
* WRITE OF PASSAGE (three different teams)
* RITE CROSS SWORDS (🚀🚀🚀)
* WRITE RIGHT RITE (planETMAxxers)
* CROSS THE AISLE (two different teams)
* REACH ACROSS THE ISLE (1e308)
* BOW TO THE BIG ASS QUESTION MARK (:praytrick:)
* DISC CORD DANCE (StriketeaMars 🪐)
* DOWN A CROSS (Organic Mathemagicians Inhabit Nascent Orb Using Soil)
* I LOVE CROSSWORDS (More About Vikings)

**Convergence**

* MANDELBROT SET (Counted Double Yakuman)
* TRY AGAIN (TErra firMA)

**Identify… INDEX, Solve**

* BIG NUMBER (Team Cirno) (Mathemagicians Offer To Help Ecological Research, Expecting Adapted Responses To Habitat)
* BRINICLE (...and in studying you must have learned to suspect FAIR PLAY so you would have put the puzzle as far from yourself as possible, so I can clearly not choose the answer in front of me\!)
* I AM ROBOT (Amateur Hour)

**Picking Up the Pieces**

* BY GUARDING A DEVELOPING BOTANICAL (Excessive Congers of r/PictureGame)
* BY GUARDING BOTANICAL ENCYCLOPEDIA (Up Goers)
* BY DEVELOPING GUARDIAN BATTALIONS (深色墨点)
* BE A PREDEFINED FACTIONAL UMBRELLA (Glub Glub)

**Reduce**

* FORM A COMPUTER VIRUS (凑不出-Hunger Air Game)
* TOP CUBAN (Shower Pomelo 🍈)

**Mark of Identification**

* YOU GUYS THOUGHT OF THIS PUZZLE AFTER WATCHING SHIKANOKO BUT ITS A MARKOV CHAIN RIGHT (StriketeaMars 🪐)
* I DONT ACTUALLY THINK ITS FAIR PLAY I JUST WANT TO SEE ALL THE DIFFERENT RESPONSES (decrypt this hunt)

**Spooflantu Cultural Exchange**

* THIS IS MADNESS THE AUTHORS SHOULD BE FORCED TO QUIGGLE TATABINK BOM TATATASHEND ZUGS AROUND THE QUAMP (Time Vultures)
* I WAS BEAT (Needlessly Eating Schist)
* WELL THATS A HELPFUL ADVICE (StriketeaMars 🪐)

**Bird’s-eye View**

* CHAOTIC MAPS (Salutecissimus)
* GIANT MOLARS (Yuki)

**True Colors**

* COLOR A DINOSAUR (300bpm jumps)
* HTTPS CRAYOLA FANDOM COM WIKI LIST OF CRAYOLA COLORS (Hee-ho)
* HYPERBOLIC ORANGE (The Blob Wizards)

**Pay $7,999,999 To Access The Premium Version Of This Puzzle**

* THIS ANSWER SUBMISSION CONSTITUTES AN OFFERING OF EIGHT MILLION BREADCRUMBS (decrypt this hunt)

**Racing Sounds**

* IM GONNA TO GO SLEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEE (Celestial \<Catellite\>)

**The Atoll**

* A TANDOORI ATTITUDE (Up Goers)
* MAKE A PEACE ACCORDION (Organic Mathemagicians Inhabit Nascent Orb Using Soil)
* RESOLVE DISCORD (Plugh (pronounced “yermom”))
* VISIT A HONDA DEALERSHIP (Quartziferous Dendrite)
* PAN LAURASIA (Nature-Employed Spirits)

**Desert Island**

* MINUS ED SHEERAN (five different teams)
* MINUS EIGHTY DEGREE LABORATORY FREEZER FOR ISS (Mushroom Kindergarten)
* YOU KNOW I WISH I HAD A PET SNAKE THAT WAS TRAINED TO SOLVE THESE MAZES FOR ME AND ITD BE COOL IF IT COULD ALSO EAT ITS OWN TAIL AS A PARTY TRICK (TErra firMA)
* *The correct answer is HUNDRED TWO but this team decided to submit one hundred O’s.*
  * OOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOO (Pan Asssigns Newly-formed Gaia As Earth's Attendant, Unfortunately Lunacy's Threatened. Invoking Mathemagicians Advised)
* I CANT BELIEVE YOU INFINITE CORRIDORD US AGAIN YOU BASTARDS (Terrestrial Species Being Invented)

**Kero’s Workshop**

<Image nameWithExt="wrapup/image21.png" />

Several teams listened to our [instructions on Bluesky](https://bsky.app/profile/galacticpuzzlehunt.com/post/3lwskl3oqpc2y) and submitted CUBES OF MEAT. Your answer may have been marked incorrect, but it was correct in our hearts.

* \[20:00:00\] ❌ Team 🐱 submitted CUBESOFMEAT for Unfamiliar Characters: Incorrect.
* \[20:00:10\] ❌ Team TErra firMA submitted CUBESOFMEAT for One-Time Use: Incorrect.
* \[20:00:18\] ❌ Team Pan Asssigns Newly-formed Gaia As Earth's Attendant, Unfortunately Lunacy's Threatened. Invoking Mathemagicians Advised submitted CUBESOFMEAT for One-Time Use: Incorrect.
* \[20:00:22\] ❌ Team TErra firMA submitted CUBESOFMEAT for A Confusing Journey: Incorrect.
* \[20:00:24\] ❌ Team Pan Asssigns Newly-formed Gaia As Earth's Attendant, Unfortunately Lunacy's Threatened. Invoking Mathemagicians Advised submitted CUBESOFMEAT for A Student's Diary: Incorrect.
* \[20:00:25\] ❌ Team Pan Asssigns Newly-formed Gaia As Earth's Attendant, Unfortunately Lunacy's Threatened. Invoking Mathemagicians Advised submitted CUBESOFMEAT for Unfamiliar Characters: Incorrect.
* \[20:00:29\] ❌ Team Frumious Bandersnatch submitted CUBESOFMEAT for Ring Cycle: Incorrect.
